export default __webpack_public_path__ + "static/media/404.af090f20.svg";